<template>
  <div class="top-box">
    <div class="top">
      <div
        class="left"
        :style="{ 'margin-left': !navStatus ? '250px' : '100px' }"
      >
        <el-select
          v-model="routeSearch"
          filterable
          clearable
          :placeholder="$t('topComponent.message')"
          @change="searchChange"
        >
          <el-option
            v-for="item in allNavList"
            :key="item.name"
            :label="item.name"
            :value="item.path || item.code"
          />
        </el-select>
      </div>
      <div class="right">
        <div class="lang">
          <el-select
            v-model="langValue"
            popper-class="top-select"
            @change="changeLang"
          >
            <el-option
              v-for="item in langOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </div>
        <div class="user">
          <el-select
            v-model="userValue"
            @change="userOptionsChange"
            placeholder=" "
            style="z-index: 2"
            popper-class="top-select"
          >
            <el-option
              v-for="item in userOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
          <img
            :src="
              store.state.userInfo.avatar ||
              require('@/static/images/avatar.png')
            "
            v-if="store.state.userInfo"
          />
        </div>
      </div>
    </div>
    <el-dialog
      v-model="outDialogVisible"
      :title="$t('commontTips')"
      width="20%"
    >
      <span>{{ $t("topComponent.tips") }}</span>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="outDialogVisible = false">{{
            $t("commonBtnCancel")
          }}</el-button>
          <el-button type="primary" @click="loginOut">{{
            $t("commonBtnConfirm")
          }}</el-button>
        </span>
      </template>
    </el-dialog>
    <el-dialog
      v-model="changePassDialogVisible"
      :title="$t('topComponent.title1')"
      width="25%"
      @close="cancelForm"
    >
      <el-form
        label-width="100px"
        :model="formData"
        style="max-width: 460px"
        :rules="formDataRules"
        ref="ruleFormRef"
      >
        <el-form-item :label="$t('topComponent.title2')" prop="oldPass">
          <el-input v-model="formData.oldPass" type="password" />
        </el-form-item>
        <el-form-item :label="$t('topComponent.title3')" prop="newPass">
          <el-input v-model="formData.newPass" type="password" />
        </el-form-item>
        <el-form-item :label="$t('topComponent.title4')" prop="confirmPass">
          <el-input v-model="formData.confirmPass" type="password" />
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="cancelForm">{{ $t("commonBtnCancel") }}</el-button>
          <el-button type="primary" @click="submitForm(ruleFormRef)">{{
            $t("commonBtnConfirmEdit")
          }}</el-button>
        </span>
      </template>
    </el-dialog>
    <el-dialog
      v-model="clearDialogVisible"
      :title="$t('commontTips')"
      width="20%"
    >
      <span>{{ $t("topComponent.tips1") }}</span>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="clearDialogVisible = false">{{
            $t("commonBtnCancel")
          }}</el-button>
          <el-button type="primary" @click="clearCache">{{
            $t("commonBtnConfirm")
          }}</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import { ref, reactive } from "vue";
import { adminUserLoginLogout, adminUserEditPassword } from "@/apis/api";
import { removeStorage, setStorage } from "@/utils/storage";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { passwordReg } from "@/utils/reg";
import { ElMessage } from "element-plus";
import MD5 from "@/utils/w_md5.js";
import i18n from "@/lang";
const { t } = i18n.global;
export default {
  props: {
    allNavList: null,
    navStatus: null,
  },
  setup(props, { emit }) {
    const router = useRouter();
    const store = useStore();
    const routeSearch = ref("");
    const langValue = store.state.lang ? ref(store.state.lang) : ref("zh");
    const userValue = ref("");
    const outDialogVisible = ref(false); //退出登录弹出框
    const changePassDialogVisible = ref(false); // 修改登录弹出框
    const clearDialogVisible = ref(false); //清除缓存确认框
    const formData = reactive({
      oldPass: "",
      newPass: "",
      confirmPass: "",
    });
    const ruleFormRef = ref(); //表单校验
    const langOptions = reactive([
      {
        label: "中文",
        value: "zh",
      },
      {
        label: "Tiếng Việt",
        value: "vn",
      },
      {
        label: "English",
        value: "en",
      },
    ]);
    const userOptions = reactive([
      {
        label: t("topComponent.title5"),
        value: "user",
      },
      {
        label: t("topComponent.title1"),
        value: "changePass",
      },
      {
        label: t("topComponent.title7"),
        value: "clear",
      },
      {
        label: t("topComponent.title6"),
        value: "out",
      },
    ]);
    const validateOldPass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(t("topComponent.error1")));
      } else if (!passwordReg.test(value)) {
        callback(new Error(t("topComponent.error2")));
      } else {
        callback();
      }
    };
    const validateNewPass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(t("topComponent.error1")));
      } else if (!passwordReg.test(value)) {
        callback(new Error(t("topComponent.error2")));
      } else if (formData.confirmPass && formData.confirmPass != value) {
        callback(new Error(t("topComponent.error3")));
      } else {
        ruleFormRef.value.clearValidate("confirmPass");
        callback();
      }
    };
    const validateConfirmPass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(t("topComponent.error1")));
      } else if (!passwordReg.test(value)) {
        callback(new Error(t("topComponent.error2")));
      } else if (formData.newPass && formData.newPass != value) {
        callback(new Error(t("topComponent.error3")));
      } else {
        ruleFormRef.value.clearValidate("newPass");
        callback();
      }
    };
    const formDataRules = reactive({
      oldPass: [
        { required: true, validator: validateOldPass, trigger: "blur" },
      ],
      newPass: [
        { required: true, validator: validateNewPass, trigger: "blur" },
      ],
      confirmPass: [
        { required: true, validator: validateConfirmPass, trigger: "blur" },
      ],
    });
    const searchChange = () => {
      emit("searchChange", routeSearch);
      routeSearch.value = "";
    };
    const userOptionsChange = () => {
      if (userValue.value == "user") {
        emit("searchChange", { value: "/mine/mineUserInfo" });
      } else if (userValue.value == "out") {
        outDialogVisible.value = true;
      } else if (userValue.value == "changePass") {
        changePassDialogVisible.value = true;
      } else if (userValue.value == "clear") {
        clearDialogVisible.value = true;
      }
      userValue.value = null;
    };
    //多语言修改
    const changeLang = () => {
      setStorage({ name: "language", content: langValue.value });
      removeStorage({ name: "selectedTab" });
      window.location.reload();
    };
    //修改密码取消
    const cancelForm = () => {
      ruleFormRef.value.resetFields();
      changePassDialogVisible.value = false;
    };
    //修改密码提交
    const submitForm = (formEl) => {
      if (!formEl) return;
      formEl.validate((valid) => {
        if (valid) {
          adminUserEditPassword({
            oldPassword: MD5.hex_md5_32(formData.oldPass),
            password: MD5.hex_md5_32(formData.newPass),
          }).then((res) => {
            cancelForm();
            ElMessage({
              message: t("topComponent.message1"),
              type: "success",
              onClose: () => {
                loginOut();
              },
            });
          });

          console.log("submit!");
        } else {
          console.log("error submit!");
          return false;
        }
      });
    };
    //退出登录
    const loginOut = () => {
      adminUserLoginLogout().then((res) => {
        if (res.success) {
          removeStorage({ name: "token" });
          removeStorage({ name: "selectedTab" });

          store.commit("SET_TABSVALUE", null);
          store.commit("SET_NAVLIST", null);
          store.commit("SET_NAVVALUE", null);
          outDialogVisible.value = false;
          router.push({
            path: "/login",
          });
          setTimeout(() => {
            store.commit("SET_TOKEN", null);
          }, 10);
        }
      });
    };
    //清除缓存
    const clearCache = () => {
      clearDialogVisible.value = false;
      emit("getTree");
    };
    return {
      routeSearch,
      langValue,
      langOptions,
      userValue,
      userOptions,
      outDialogVisible,
      changePassDialogVisible,
      clearDialogVisible,
      formData,
      formDataRules,
      ruleFormRef,
      store,
      searchChange,
      userOptionsChange,
      submitForm,
      cancelForm,
      loginOut,
      changeLang,
      clearCache,
    };
  },
};
</script>
<style lang="scss" scoped>
.top {
  height: 65px;
  background: #20222a;
  display: flex;
  justify-content: space-between;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  z-index: 10;
  :deep(.el-input) {
    margin-top: 15px;
  }
  :deep(.el-input__wrapper) {
    background: transparent;
    box-shadow: none !important;
  }
  :deep(.el-input__inner),
  :deep(.el-input__inner::placeholder) {
    color: #a79178;
    text-align: right;
    font-size: 13px;
  }
  :deep(.el-select .el-input.is-focus .el-input__wrapper) {
    box-shadow: none !important;
  }
  .left {
    width: 400px;
    margin-left: 50px;
  }
  .right {
    display: flex;
    justify-content: flex-start;
    .lang {
      :deep(.el-select) {
        margin-top: 3px;
      }
    }
    .lang {
      margin: 0 10px;
      width: 120px;
    }
    .user {
      margin: 0 10px;
      width: 65px;
      :deep(.el-icon) {
        margin-top: 8px;
      }
    }
    .user {
      position: relative;
      :deep(.el-input__inner) {
        opacity: 0;
      }
      img {
        width: 24px;
        height: 24px;
        border-radius: 50%;
        position: absolute;
        left: 0;
        top: 20px;
        padding: 2px;
        border: 1px solid #eee;
      }
    }
  }
}
</style>